import { type FC } from 'react';

import { useCardOfferPublisherContext } from '@/microfrontends/listing/shared/context/selectors/cardData';
import { useCAForCard } from '@/microfrontends/listing/shared/hooks/card/useCAForCard';

import { Link } from '@/packages/shared-ui';
import { stopPropagation } from '@/packages/utils/event/stopPropagation';

export const PublisherMoreOffersContainer: FC = () => {
  const { publishedOffersPageUrl } = useCardOfferPublisherContext();

  const caForCard = useCAForCard();

  if (!publishedOffersPageUrl) {
    return null;
  }

  const handleTrack = (): void => {
    caForCard({ action: 'click_sopr', category: 'Listing', label: 'to_publisher_objects' });
  };

  return (
    <Link
      behaviour="hover_primary_to_primary_hover"
      href={publishedOffersPageUrl}
      track={handleTrack}
      onClick={stopPropagation}
    >
      Посмотреть все объекты
    </Link>
  );
};
